<div class="spinner-wrapper" [ngClass]="{ 'fullscreen': fullscreen, 'opaque': opaque }">
    <div class="spinner" [style]="{ width: diameter + 'px', height: diameter + 'px' }">
      <hr />
      <hr />
      <hr />
      <hr />
    </div>
</div>
